import { useEffect, useRef, useState } from 'react';

// Tracks container *width* only via ResizeObserver -- height is computed
// synchronously by layout.js from props (indicator count, etc.), never
// measured from the DOM. Mixing "measure height" with "set height" is what
// caused the old implementation's setTimeout-guarded correction loop and
// visible height-snap on every indicator toggle.
export default function useResizeObserver() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    setWidth(node.offsetWidth);

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const newWidth = entry.contentRect.width;
      setWidth((prev) => (Math.abs(prev - newWidth) > 0.5 ? newWidth : prev));
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
}
